import { DeviceTypeTriggerCatalogue } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import {
    RegisteredEventApi,
    RegisteredEventsByDeviceTypeApi,
} from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-trigger-catalogue.api';

type IdentifiedEvent = RegisteredEventApi & { id: string };

const isSelectableEvent = (event: RegisteredEventApi): event is IdentifiedEvent => Boolean(event.id);

export const mapTriggerCatalogueFromApi = (
    deviceTypeIds: string[],
    eventsByDeviceType: RegisteredEventsByDeviceTypeApi
): DeviceTypeTriggerCatalogue[] =>
    deviceTypeIds.map((deviceTypeId) => ({
        deviceTypeId,
        triggers: (eventsByDeviceType[deviceTypeId] ?? []).filter(isSelectableEvent).map((event) => ({
            id: event.id,
            displayName: event.displayName ?? event.id,
            deviceTypeId,
            neverIdentifiedAnOperator: event.operatorAttributed === 0,
        })),
    }));
